import styles from './popups.module.css'
import { useDispatch } from 'react-redux'
import { setSettingsTab } from '../../features/authSlice'
import ButtonCustom from '../atoms/button/ButtonCustom'
import { useNavigate } from 'react-router-dom'
import CommonDeleteModal from '../atoms/modal/CommonDeleteModal'

export const GeneralPaymentPopup = ({ clickHandler, heading = "Upgrade now to unlock full access to your wedding tools"}) => {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	return (
		<CommonDeleteModal
			open={true}
			handleClose={clickHandler}
			heading={heading}
			ClassIcon={styles.detailModalIcon}
			Icon={'/images/info-circle.svg'}
			footerContent={
				<>
					<ButtonCustom
						variant="default"
						size="lg"
						onClick={() => {
							navigate('/settings')
							dispatch(setSettingsTab(4))
						}}
					>
						View Plans
					</ButtonCustom>
					<ButtonCustom
						variant="outlined"
						size="lg"
						onClick={clickHandler}
					>
						Maybe Later
					</ButtonCustom>
				</>
			}
		/>
	)
}
